import _ from 'underscore'

/**
 * 컬랙션에서 TOJSON 을 도와줍니다.
 * @param {*} extModel
 */
export function toJSONHelper(extModel) {
  if (_.isArray(extModel)) {
    var newArray = _.map(extModel, function (item) {
      return item.attributes
    })
    return newArray
  } else {
    throw new Error('IS NOT ARRAY')
  }
}
